import { UpvoteList } from "../types";

export const defaultListData: UpvoteList[] = [
  { id: 1, votes: [{ id: 1, selected: false }] },
  { id: 2, votes: [{ id: 1, selected: false }] },
  { id: 3, votes: [{ id: 1, selected: false }] },
];
